import { createI18n } from "vue-i18n";

const messages = {};

const supportedLanguages = ["en", "sr"]; //initialize with supported languages. Will be changed later

const defaultLanguage = "en";

const i18n = createI18n({
  locale: defaultLanguage,
  fallbackLocale: defaultLanguage,
  messages,
  warnHtmlInMessage: "off",
});

export { i18n, supportedLanguages, defaultLanguage };
